<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-3 col-lg-3 col-xl-4 custom-width-desktop">
        <div class="scrollable-container">
          <div class="scrollable-div bg-light shadow-lg rounded-lg p-2">
            <div class="text-center">
              <h2>
                Der TV-Finder
                <img src="https://findingo.de/wp-content/uploads/2024/12/cropped-logo_small.png" class="img-fluid"
                  style="width: 20%;" alt="...">
              </h2>
              <h4 class="h4 mt-2" style="font-family:Open Sans,Arial,sans-serif">
                Zu viel Technik? Dann probiere unsere smarte und unabhängige <a href="https://findingo.de/fernseher/tv-kaufberatung/"
                  style="font-size:1.3rem;color: #007bff; text-decoration: underline;">TV-Kaufberatung</a> aus!
              </h4>
            </div>
            <form method="GET" name="finder-form" id="finder-form" @change="onFormChange">
              <div class="formContent p-2">
                <div class="row row-cols-2">
                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Hersteller
                    </span>
                    <select v-model="filters.brand" id="brand" name="brand"
                      class="spanSelectField form-select form-select-lg mb-1">
                      <option value="Alle" selected>Alle</option>
                      <option value="Grundig">Grundig</option>
                      <option value="Hisense">Hisense</option>
                      <option value="JVC">JVC</option>
                      <option value="LG">LG</option>
                      <option value="Medion">Medion</option>
                      <option value="Panasonic">Panasonic</option>
                      <option value="Philips">Philips</option>
                      <option value="Samsung">Samsung</option>
                      <option value="Sharp">Sharp</option>
                      <option value="Sony">Sony</option>
                      <option value="TCL">TCL</option>
                    </select>
                  </div>
                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Auflösung
                    </span>
                    <select v-model="filters.resolution" id="resolution" name="resolution"
                      class="spanSelectField form-select form-select-lg mb-1">

                      <option value="Alle" selected>Alle</option>
                      <option value="1920x1080">1920x1080 (FULL HD)</option>
                      <option value="3840x2160">3840x2160 (4K)</option>
                      <option value="7680x4320">7680x4320 (8K)</option>
                    </select>
                  </div>
                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">
                      Größe
                    </span>
                    <select v-model="filters.size" id="size" name="size"
                      class="spanSelectField form-select form-select-lg mb-1">
                      <option value="0" selected>Alle</option>
                      <option value="30">30" - 40"</option>
                      <option value="40">40" - 50"</option>
                      <option value="50">50" - 65"</option>
                      <option value="65">65" - 75"</option>
                      <option value="75">Größer als 75"</option>
                    </select>
                  </div>
                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Display-Art</span>

                    <select v-model="filters.display" id="display" name="display"
                      class="spanSelectField form-select form-select-lg mb-1">

                      <option value="Alle" selected>Alle</option>
                      <option value="Edge LED">Edge LED</option>
                      <option value="Direct LED">Direct LED</option>
                      <option value="QLED">QLED</option>
                      <option value="Neo QLED">Neo QLED</option>
                      <option value="Mini LED">Mini LED</option>
                      <option value="OLED">OLED</option>
                    </select>
                  </div>
                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Reaktionszeit</span>

                    <select v-model="filters.reaktionszeit" id="reactionTime" name="reactionTime"
                      class="spanSelectField spanSelectField form-select form-select-lg mb-1">
                      <option value="0" selected>Alle</option>
                      <option value="20">20 ms</option>
                      <option value="15">15 ms</option>
                      <option value="10">10 ms</option>
                      <option value="8">8 ms</option>
                      <option value="6">6 ms</option>
                      <option value="4">4 ms</option>
                      <option value="2">2 ms</option>
                      <option value="1">1 ms</option>
                    </select>
                  </div>

                  <!--
                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Input-Lag</span>

                    <select v-model="filters.inputLag" id="inputLag" name="inputLag"
                      class="spanSelectField spanSelectField form-select form-select-lg mb-1">
                      <option value="0" selected>Alle</option>
                      <option value="20">20 ms</option>
                      <option value="15">15 ms</option>
                      <option value="10">10 ms</option>
                      <option value="5">5 ms</option>
                    </select>
                  </div> -->

                  <div class="ml-2 mb-3 w-[80%]">

                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Frequenz</span>

                    <select v-model="filters.frequenzVertikal" id="frequenzVertikal" name="frequenzVertikal"
                      class="spanSelectField form-select form-select-lg mb-1">

                      <option value="0" selected>Alle</option>
                      <option value="60">60 Hz</option>
                      <option value="100">100 Hz</option>
                      <option value="120">120 Hz</option>
                      <option value="144">144 Hz</option>
                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">

                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Spitzenhelligkeit</span>

                    <select v-model="filters.spitzenhelligkeit" id="spitzenhelligkeit" name="spitzenhelligkeit"
                      class="spanSelectField form-select form-select-lg mb-1">

                      <option value="0" selected>Alle</option>
                      <option value="200">200 cdm</option>
                      <option value="300">300 cdm</option>
                      <option value="400">400 cdm</option>
                      <option value="500">500 cdm</option>
                      <option value="700">700 cdm</option>
                      <option value="900">900 cdm</option>
                      <option value="1100">1100 cdm</option>
                      <option value="1300">1300 cdm</option>
                      <option value="1500">1500 cdm</option>
                      <option value="1800">1800 und mehr cdm</option>
                    </select>
                  </div>

                       <div class="ml-2 mb-3 w-[80%]">
                          <span
                            class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">VRR</span>
                          <select v-model="filters.isvrr" id="isvrr" name="isvrr"
                            class="spanSelectField form-select form-select-lg mb-1">
                            <option value="2" selected>Alle</option>
                            <option value="1">Ja</option>
                          </select>
                        </div>

                </div>

                <div class="">
                  <div class="mb-1 flex">
                    <h4
                      class="text-xs text-center  font-semibold  mb-2 py-1 px-2 uppercase rounded text-black uppercase last:mr-0 mr-1">
                      Anschlüsse
                    </h4>
                  </div>
                  <div style="padding-top:0px;">
                    <div class="row" style="margin-left:15%">
                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="hdmi_2_1" v-model="filters.hdmi_2_1"
                            value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="hdmi"> HDMI 2.1</label>
                        </div>
                      </div>
                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="ethernet"
                            v-model="filters.ethernet_rj45" value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="ethernet">WLAN</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5" id="slider"></div>
                <input type="text" id="minCost" readonly hidden>
                <input type="text" id="maxCost" readonly hidden>
                <div class="mt-3">
                  <details>
                    <summary>Weitere TV-Eigenschaften</summary>
                    <div class="container pt-2">
                      <div class="row row-cols-2">
                        <div class="col-md-6">
                          <div class="ml-2 mb-3 w-[80%]">
                            <span
                              class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">HDR</span>
                            <select v-model="filters.hdr" id="hdr" name="hdr"
                              class="spanSelectField form-select form-select-lg mb-1">
                              <option value="Alle" selected>Alle</option>
                              <option value="HDR10">HDR10</option>
                              <option value="HDR10Plus">HDR10 Plus</option>
                              <option value="HDRQuantum">HDR Quantum</option>
                              <option value="DolbyVision">Dolby Vision</option>
                              <option value="DolbyVisioniq">Dolby Vision IQ</option>

                            </select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="ml-2 mb-3 w-[80%]">
                            <span
                              class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">PPI/DPI</span>
                            <select v-model="filters.ppi" id="ppi" name="ppi"
                              class="spanSelectField form-select form-select-lg mb-1">
                              <option value="0" selected>ab 20 Pixel pro Zoll</option>
                              <option value="60">ab 40 Pixel pro Zoll</option>
                              <option value="60">ab 60 Pixel pro Zoll</option>
                              <option value="80">ab 80 Pixel pro Zoll</option>
                              <option value="100">ab 100 Pixel pro Zoll</option>
                              <option value="110">ab 110 Pixel pro Zoll</option>
                              <option value="120">ab 120 Pixel pro Zoll</option>
                              <option value="130">ab 130 Pixel pro Zoll</option>
                              <option value="140">ab 140 Pixel pro Zoll</option>
                              <option value="150">ab 150 Pixel pro Zoll</option>
                              <option value="160">ab 160 Pixel pro Zoll</option>
                            </select>
                          </div>
                        </div>
                        <div class="ml-2 mb-3 w-[80%]">
                          <span
                            class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Ambilight</span>
                          <select v-model="filters.ambilight" id="ambilight" name="ambilight"
                            class="spanSelectField form-select form-select-lg mb-1">
                            <option value="2" selected>Alle</option>
                            <option value="1">Ja(schränkt stark ein)</option>
                          </select>
                        </div>
                        <div class="col-md-6">
                          <div class="ml-2 mb-3 w-[80%]">
                            <span
                              class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Energieklasse (SDR)</span>
                            <select v-model="filters.energieklasse" id="energyclass" name="energyclass"
                              class="spanSelectField form-select form-select-lg mb-1">
                              <option value="Alle" selected>Alle</option>
                              <option value="D">D</option>
                              <option value="E">E</option>
                              <option value="F">F</option>
                              <option value="G">G</option>
                            </select>
                          </div>
                        </div>
                        <div class="ml-2 mb-3 w-[80%]">
                          <span
                            class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Vesa-Halterung</span>
                          <select v-model="filters.isVesa" id="vesa" name="vesa"
                            class="spanSelectField form-select form-select-lg mb-1">
                            <option value="2" selected>Alle</option>
                            <option value="1">Ja</option>
                          </select>
                        </div>
                        
                        <div class="ml-2 mb-3 w-[80%]">
                          <span
                            class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">stat. Kontrast</span>
                          <select v-model="filters.kontrastStatisch" id="kontrastStatisch" name="kontrastStatisch"
                            class="spanSelectField form-select form-select-lg mb-1">
                            <option value="0" selected>Alle</option>
                            <option value="1000">1000</option>
                            <option value="2000">2000</option>
                            <option value="3000">3000</option>
                            <option value="4000">4000</option>
                            <option value="5000">5000</option>
                            <option value="6000">6000</option>
                          </select>
                        </div>
                        
                        <div class="col-md-6">
                          <div class="ml-2 mb-3 w-[80%]">
                            <span
                              class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Betriebssystem</span>
                            <select v-model="filters.betriebssystem" id="betriebssystem" name="betriebssystem"
                              class="spanSelectField form-select form-select-lg mb-1">
                              <option value="Alle" selected>Alle</option>
                              <option value="Tizen">Tizen</option>
                              <option value="Google TV">Google TV</option>
                              <option value="webOS">webOS</option>
                              <option value="Titan">Titan</option>
                              <option value="VIDAA">VIDAA</option>

                            </select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="ml-2 mb-3 w-[80%]">
                            <span
                              class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">Gehäusefarbe</span>
                            <select v-model="filters.farbe" id="colour" name="farbe"
                              class="spanSelectField form-select form-select-lg mb-1">
                              <option value="Alle" selected>Alle</option>
                              <option value="Schwarz">Schwarz</option>
                              <option value="Anthrazit">Anthrazit</option>
                              <option value="Grau">Grau</option>
                              <option value="Weiß">Weiß</option>
                              <option value="Silber">Silber</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </details>
                </div>
                <div class="form-footer mt-2">
                  <button type="reset" class="btn btn-secondary btn-sm px-4 py-2">Auswahl zurücksetzen</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-9 col-lg-9 col-xl-8">
        <div v-if="loading" class="loading-spinner"></div>
        <div v-else class="pt-4">

          <div class="row mb-5 gy-5">

  <div class="col-lg-4" v-if="topProducts.bestVal">
    <div class="winner-card">
      <div class="badge-ribbon badge-gaming">
        <i class="fa-solid fa-gamepad me-2"></i> Gaming: Preis/Leistung Tipp
      </div>
      <div class="p-3" style="padding-bottom: 0px !important;">
        <h5 class="text-center">{{ topProducts.bestVal.amazonNamenSuche }}</h5>
        <pic-carousel :product="topProducts.bestVal" />

        <div class="mt-3 mb-3" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background-color: #050505; border: 2px solid #050505; border-radius: 2px; overflow: hidden;">
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-tv" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.diagonale }} Zoll</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-expand" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.horizontalpixel }}x{{ topProducts.bestVal.vertikalpixel }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-circle-half-stroke" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.paneltech || topProducts.bestVal.paneltyp }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-bolt" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestVal.frequenzvertikal_merged === '0.00' || !topProducts.bestVal.frequenzvertikal_merged ? 'k.A.' : topProducts.bestVal.frequenzvertikal_merged + ' Hz' }}</span>
          </div>
        </div>

        <div class="text-center">
          <div class="footer-content d-flex justify-content-between">
            <div class="shop-info">
              <img class="shop-icon" src="/wp-content/plugins/tv-finder/amazon_icon.png" alt="Amazon Logo" />
              <div class='' style='text-align: left; font-size: 12px;'>aktualisiert: {{ topProducts.bestVal.updated_time }}</div>
            </div>
            <div class="amazon-info">
              <div>
                <div class="no_click">
                  <span class="price">{{ formatPreis(topProducts.bestVal.preisAmazonNeu) }} €</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a :href="topProducts.bestVal.amazon_url" rel="sponsored nofollow noopener" target="_blank" class="btn btn-primary w-100">Zum Angebot*</a>
    </div>
  </div>

  <div class="col-lg-4" v-if="topProducts.bestAverage">
    <div class="winner-card">
      <div class="badge-ribbon badge-testsieger">
        <i class="fa-solid fa-display me-2"></i>Allrounder: Preis/Leistung Tipp
      </div>
      <div class="p-3" style="padding-bottom: 0px !important;">
        <h5 class="text-center">{{ topProducts.bestAverage.amazonNamenSuche }}</h5>
        <pic-carousel :product="topProducts.bestAverage" />

        <div class="mt-3 mb-3" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background-color: #050505; border: 2px solid #050505; border-radius: 2px; overflow: hidden;">
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-tv" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.diagonale }} Zoll</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-expand" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.horizontalpixel }}x{{ topProducts.bestAverage.vertikalpixel }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-circle-half-stroke" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.paneltech || topProducts.bestAverage.paneltyp }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-bolt" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestAverage.frequenzvertikal_merged === '0.00' || !topProducts.bestAverage.frequenzvertikal_merged ? 'k.A.' : topProducts.bestAverage.frequenzvertikal_merged + ' Hz' }}</span>
          </div>
        </div>

        <div class="text-center">
          <div class="footer-content d-flex justify-content-between">
            <div class="shop-info">
              <img class="shop-icon" src="/wp-content/plugins/tv-finder/amazon_icon.png" alt="Amazon Logo" />
              <div class='' style='text-align: left; font-size: 12px;'>aktualisiert: {{ topProducts.bestAverage.updated_time }}</div>
            </div>
            <div class="amazon-info">
              <div>
                <div class="no_click">
                  <span class="price">{{ formatPreis(topProducts.bestAverage.preisAmazonNeu) }} €</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a :href="topProducts.bestAverage.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <button class="btn-primary w-100">Zum Angebot*</button>
      </a>
    </div>
  </div>

  <div class="col-lg-4" v-if="topProducts.bestPreis">
    <div class="winner-card">
      <div class="badge-ribbon badge-preisleistung">
        <i class="fa-solid fa-piggy-bank me-2"></i>Kleinster Preis
      </div>
      <div class="p-3" style="padding-bottom: 0px !important;">
        <h5 class="text-center">{{ topProducts.bestPreis.amazonNamenSuche }}</h5>
        <pic-carousel :product="topProducts.bestPreis" />

        <div class="mt-3 mb-3" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1px; background-color: #050505; border: 2px solid #050505; border-radius: 2px; overflow: hidden;">
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-tv" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.diagonale }} Zoll</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-expand" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.horizontalpixel }}x{{ topProducts.bestPreis.vertikalpixel }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-circle-half-stroke" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.paneltech || topProducts.bestPreis.paneltyp }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 p-2" style="background-color: #f4f4f4;">
            <i class="fa-solid fa-bolt" style="color: #737373; font-size: 16px; width: 16px; text-align: center;"></i>
            <span style="font-size: 13px; font-weight: 550; color: #050505; line-height: 1;">{{ topProducts.bestPreis.frequenzvertikal_merged === '0.00' || !topProducts.bestPreis.frequenzvertikal_merged ? 'k.A.' : topProducts.bestPreis.frequenzvertikal_merged + ' Hz' }}</span>
          </div>
        </div>

        <div class="text-center">
          <div class="footer-content d-flex justify-content-between">
            <div class="shop-info">
              <img class="shop-icon" src="/wp-content/plugins/tv-finder/amazon_icon.png" alt="Amazon Logo" />
              <div class='' style='text-align: left; font-size: 12px;'>aktualisiert: {{ topProducts.bestPreis.updated_time }}</div>
            </div>
            <div class="amazon-info">
              <div>
                <div class="no_click">
                  <span class="price">{{ formatPreis(topProducts.bestPreis.preisAmazonNeu) }} €</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a :href="topProducts.bestPreis.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <button class="btn-primary w-100">Zum Angebot*</button>
      </a>
    </div>
  </div>
</div>

          <div class="row g-4">
            <template v-for="(product, index) in products" :key="product.id">
    <div 
      v-if="
        product.id !== topProducts.bestPreis?.id &&
        product.id !== topProducts.bestAverage?.id &&
        product.id !== topProducts.bestVal?.id
      "
      class="col-12 col-sm-6 col-lg-4 mb-4"
      :class="getCardAnimationClass(index)"
    >
              <div class="card" :class="{ 'is-flipped': isFlipped(index) }">
                <div class="card-front">
                  <h5 class="card-title text-center mt-3 mx-5">
                    {{ product.amazonNamenSuche }}
                  </h5>
                  <pic-carousel :product="product" />
                  <div class="energy-sign" style='height:22px;'>
                    <img :src="product.energiePic" />
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-lg-6">
                        <div class="d-flex flex-column">
                          <div>
                            <span class="label-data-front mx-2">Größe</span>
                          </div>
                          <div>
                            <span class="ml-2">{{ product.diagonale }} Zoll</span>
                          </div>
                          <div>
                            <span class="label-data-front mx-2">Display</span>
                          </div>
                          <div>
                            <span
                              v-if="product.paneltech === null || product.paneltech === undefined || product.paneltech === ''">{{
                              product.paneltyp }}</span>
                            <span v-else>{{ product.paneltech }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-lg-6">
                        <div class="d-flex flex-column">
                          <div>
                            <span class="label-data-front mx-2">Auflösung</span>
                          </div>
                          <div>
                            <span class="ml-2">{{ product.horizontalpixel }}x{{ product.vertikalpixel }}</span>
                          </div>
                          <div>
                            <span class="label-data-front mx-2">Frequenz</span>
                          </div>
                          <div>
                            <span
                              v-if="product.frequenzvertikal_merged === '0.00' || product.frequenzvertikal_merged === 0 || product.frequenzvertikal_merged == null || isNaN(Number(product.frequenzvertikal_merged))">
                              Keine Information
                            </span>
                            <span v-else>{{ product.frequenzvertikal_merged }} Hz</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button class="datasheet-button" @click="flipCard(index)">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i> Datenblatt anzeigen
                  </button>
                  <div class="card-footer">
                    <div class="footer-content d-flex justify-content-between">
                      <div class="shop-info">
                        <span class="no_click" style='text-align: left;'>Amazon.de</span>
                        <div class='' style='text-align: left; font-size: 12px;'>
                          aktualisiert: {{ product.updated_time }}
                        </div>
                      </div>
                      <div class="amazon-info">
                        <div class="pb-2">
                          <div class="no_click pb-1" style="text-align:left;">
                            <img class="shop-icon" style="margin-right: 4px;"
                              src="/wp-content/plugins/tv-finder/amazon_icon.png" alt="Amazon Logo" />
                            <span class="mr-2">| </span><span class="price"> {{ product.preisAmazonNeu }}€</span><br />
                          </div>
                          <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                            <button class="btn12 px-3 py-1">zum Angebot*</button>
                          </a>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="card-back">
                  <div class="card-body">
                    <DatenblattMod :product="product" />
                  </div>
                  <div>
                    <button class="datasheet-button" @click="flipCard(index)"><i
                        class="fa-solid fa-rotate-left icon-margin-right"></i>Zurück zur Übersicht</button>
                  </div>
                </div>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button class="datasheet-button" @click="updateTv">
          Mehr TVs laden
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import PicCarousel from "./PicCarousel.vue";
import DatenblattMod from "./DatenblattMod.vue";

export default {

  components: {
    PicCarousel,
    DatenblattMod,
  },
  name: 'TVFinderApp',
  props: {

  },


  data() {
    return {
      flippedCards: [], 
      products: [],
      topProducts: {
        bestPreis: null,
        bestAverage: null,
        bestVal: null
      },
      loading: false,
      loadedProducts: [],
      productsPerLoad: 9, 
      loadedProductIndex: 9,

      filters: {
        brand: 'Alle',
        resolution: 'Alle',
        size: '0',
        display: 'Alle',
        inputLag: '0',
        reaktionszeit: '0',
        frequenzVertikal: '0',
        hdr: 'Alle',
        hdmi_2_1: '0',
        minPrice: '150',
        maxPrice: '7500',
        farbe: "Alle",
        energieklasse: "Alle",
        technologie: 'Alle',
        isVesa: "2",
        kontrastStatisch: "0",
        isSubwoofer: "2",
        spitzenhelligkeit: "0",
        ambilight: "2",
        betriebssystem: "Alle",
        ethernet_rj45: "0",
        ppi: "0",
        isvrr: "2",
      }
    };
  },
  methods: {

    formatPreis(preis) {
      if (!preis) return '';
      return parseFloat(preis).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    initializeSlider() {
      var slider = document.getElementById('slider');
      noUiSlider.create(slider, {
        connect: true,
        behaviour: 'tap',
        start: [this.filters.minPrice, this.filters.maxPrice],
        format: wNumb({
          decimals: 0,
          suffix: ' (€)',
        }),
        tooltips: true,
        range: {
          'min': [0],
          '85%': [1500, 50],
          '95%': [2000, 500],
          'max': [10000]
        }
      });

      slider.noUiSlider.on('change', () => {
        this.filters.minPrice = parseInt(slider.noUiSlider.get()[0].replace(' (€)', ''));
        this.filters.maxPrice = parseInt(slider.noUiSlider.get()[1].replace(' (€)', ''));
        this.fetchProducts(this.filters);
      });

      var minCostInput = document.getElementById('minCost');
      var maxCostInput = document.getElementById('maxCost');

      minCostInput.addEventListener('change', () => {
        slider.noUiSlider.set([minCostInput.value.replace(' (€)', ''), null]);
      });

      maxCostInput.addEventListener('change', () => {
        slider.noUiSlider.set([null, maxCostInput.value.replace(' (€)', '')]);
      });
    },

    onFormChange() {
      this.fetchProducts(this.filters);
    },

    fetchProducts(filters) {
      this.loading = true;
      this.loadedProductIndex = 9;
      $.ajax({
        url: '/wp-content/plugins/tv-finder/testNeuFinderApp.php',
        method: 'POST',
        dataType: 'json',
        data: {
          filters: filters,
          limit: this.loadedProductIndex
        },
        success: (response) => {
          this.loading = false; 
          this.products = response.filteredProducts;

          if(response.topProducts){
            this.topProducts = response.topProducts;
          }
        },
        error: (xhr, status, error) => {
          console.error('AJAX Fehler:', status, error);
        }
      });
    },

    flipCard(index) {
      const cardIndex = this.flippedCards.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards.push(index);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },

    isFlipped(index) {
      return this.flippedCards.includes(index);
    },

    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInUp animate__${delay}ms`;
    },

    updateTv() {
      this.loadedProductIndex += 9;
      $.ajax({
        url: "/wp-content/plugins/tv-finder/testNeuFinderApp.php",
        method: "POST",
        data: {
          filters: this.filters,
          limit: this.loadedProductIndex
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
        },
        error: (error) => {
        },
      });
    }
  },

  mounted() {
    this.initializeSlider();
    this.fetchProducts(this.filters); 
  }
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.form-check-input[type="checkbox"].form-check-input {
  width: 40px;
  height: 20px;
}

.form-check-input[type="checkbox"].form-check-input {
  margin-right: 10px;
  padding: 5px;
}

.bg-cs-color {
  background-color: #b9d1ff;
}

.spanField {
  border-radius: 10px 10px 0 0;
}

.spanSelectField {
  border-radius: 0 10px 10px 10px;
  border-width: 1px;
  border-color: #DDD1C5
}

.spanSelectField:focus {
  outline: none;
  border-color: #c2ab9282;
  box-shadow: 0 0 5px #c2ab9282;
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 5px;
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display: flex;
}

.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.card-back {

  transform: rotateY(180deg);
  position: absolute;
  background: #fff;
}

.label-data-front {
  color: #999
}

@media (min-width: 992px) {
  .custom-width-desktop {
    width: 25%;
  }
}

.scrolly {
  max-height: 900;
  overflow-y: auto;
  border: 1px solid #ccc;
}

.icon-margin-right {
  margin-right: 8px;
  
}

.loading-spinner {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #c2ab9282;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.shop-info {
  text-align: left;
}

.scrollable-div::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}


.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
  border: 3px solid #f1f1f1;
}


.scrollable-div::-webkit-scrollbar {
  width: 12px;
}

.scrollable-div {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

.scrollable-container {
  height: auto !important;
  overflow-y: visible;
  position: static;
}

@media (min-width: 992px) {
  .scrollable-container {
    height: 1000px !important;
    overflow-y: auto;
    position: sticky;
    top: 0px;
  }
}

.btn12 {
  background-color: #fa890052;
  border: 1px solid #222 !important;
}

/* --- WINNER CARD STYLES --- */
.winner-card {
  background-color: #ffffff;
  border: 2px solid #2f2a26;
  box-shadow: 4px 4px 0px #2f2a26;
  position: relative;
  transition: all 0.2s ease-in-out;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  height: 100%; 
  margin-top: 15px; 
}

@media (min-width: 992px) {
  .winner-card {
    margin-bottom: 0;
  }
}

.winner-card:hover {
  transform: translateY(-2px);
  box-shadow: 6px 6px 0px #1a1a1a;
}

.winner-card > .p-3 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 1.5rem !important;
}

.winner-card h5 {
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.winner-card .price {
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  display: block;
  margin-top: auto;
}

.badge-ribbon {
  position: absolute;
  top: -25px;
  left: -12px;
  padding: 8px 16px;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  letter-spacing: 0.05em;
  font-size: 0.875rem;
  z-index: 10;
  box-shadow: 2px 2px 0px #1a1a1a;
}

.badge-ribbon::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  border-left: 8px solid transparent;
}

.badge-testsieger {
  background-color: #627282;
  color: white;
}
.badge-testsieger::after {
  border-top: 8px solid #627282; 
}

.badge-preisleistung {
  background-color: #2f2a26;
  color: white;
}
.badge-preisleistung::after {
  border-top: 8px solid #000000;
  opacity: 0.8; 
}

.badge-gaming {
  background-color: #0d6efd;
  color: white;
}
.badge-gaming::after {
  border-top: 8px solid #2a2a2a;
}

.winner-card a {
  display: block;
  width: 100%;
  text-decoration: none;
  margin-top: auto;
}

.btn-primary {
  background-color: #f45d2f;
  color: white;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  padding: 16px; 
  border-radius: 0;
  transition: background-color 0.2s;
  cursor: pointer;
  display: block; 
}

.btn-primary:hover {
  background-color: #d14016;
}
</style>
